(
    function ($) {
        function debounce(func, wait = 20, immediate = true) {
            var timeout;
            return function() {
                var context = this, args = arguments;
                var later = function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        }
        $(document).ready(function () {
            const sliderImages = document.querySelectorAll('.marathon-slide-in');
            function checkSlide() {
                sliderImages.forEach(sliderImage => {
                    const elementHeight = sliderImage.clientHeight
                    const offsetTop = sliderImage.offsetTop
                    if (sliderImage.classList.contains('active')) {
                        return;
                    }
                    // half way through the image
                    const slideInAt = (window.scrollY + window.innerHeight) - elementHeight / 2;
                    // bottom of the image
                    const imageBottom = offsetTop + elementHeight;
                    const isHalfShown = slideInAt > offsetTop;
                    // const isNotScrolledPast = window.scrollY < imageBottom;
                    // if (isHalfShown && isNotScrolledPast) {

                    if (isHalfShown) {
                        sliderImage.classList.add('active');
                    }
                    // else {
                    //     sliderImage.classList.remove('active');
                    // }
                });
            }

            window.addEventListener('scroll', debounce(checkSlide));


            $('.share-button__action').click(function (e) {
                if (navigator.share) {
                    navigator.share({
                        url: document.location.href,
                    })
                        .then(() => console.log('Successful share'))
                        .catch((error) => console.log('Error sharing', error));
                } else {
                    const webSocialShare =
                        document.querySelector('web-social-share');
                    const shareUrl = document.location.href;
                    const share = {
                        displayNames: true,
                        config: [{
                            twitter: {
                                socialShareUrl: shareUrl,
                                socialSharePopupWidth: 300,
                                socialSharePopupHeight: 400
                            }
                        },{
                            email: {
                                socialShareBody: shareUrl
                            }
                        }, {
                            whatsapp: {
                                socialShareUrl: shareUrl
                            }
                        }]
                    };
                    webSocialShare.share = share;
                    // Show/open the share actions
                    webSocialShare.show = true;
                }
            });
            $('.slick-carousel').each(function () {
                const dataset = this.dataset;
                const config = {
                    dots: true,
                    arrows: false,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 1,
                    adaptiveHeight: true,
                    autoplaySpeed: 3000,
                };
                Object.keys(dataset).forEach(k => {
                    let value = dataset[k];
                    if (value === "true" || value === "false") {
                        value = Boolean(value)
                    }
                    config[k] = value;
                });
                console.log(config);
                $(this).slick(config);
            })

            // Check for click events on the navbar burger icon
            $(".navbar-burger").click(function () {

                // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
                $(".navbar-burger").toggleClass("is-active");
                $(".navbar-menu").toggleClass("is-active");

            });

            $('[data-toggle="modal"]').click(function () {
                $($(this).data('target')).addClass("is-active");
            });
            $(".modal-close").click(function () {
                $(".modal").removeClass("is-active");
            });
            $(".modal-close-no-style").click(function () {
                $(".modal").removeClass("is-active");
            });

            $('[data-toggle="tabs"] a').click(function (e) {
                const link = $(this);
                const href = link.attr("href");
                if (href[0] !== "#") {
                    return;
                }
                e.preventDefault();
                $('[data-toggle="tabs"] li.is-active').removeClass("is-active");
                link.parent().addClass("is-active");
                const tabContainer = $($('[data-toggle="tabs"]').data("tabs"));
                tabContainer.children('.content-tab').each(function () {
                    console.log("#" + $(this).attr("id"), href, this.className);
                    if ("#" + $(this).attr("id") === href) {
                        $(this).removeClass("is-hidden");
                    } else {
                        $(this).addClass("is-hidden");
                    }
                });
                // console.log($(this));
                // $($(this).data('target')).addClass("is-active");
            });
            $("button.delete").click(function () {
                $(this).closest('.notification').remove();
            });
        });
        const scrolltop = $('.yoga-scrolltop');
        const mainTop = $("main.main").offset().top;
        scrolltop.click(function () {
            $("html,body").animate({scrollTop:mainTop - 100},"1000");
        });
        $(window).scroll(function () {
            if (this.scrollY > mainTop ) {
                if (!scrolltop.hasClass("visible")) {
                    scrolltop.addClass("visible");
                }
            } else {
                if (scrolltop.hasClass("visible")) {
                    scrolltop.removeClass("visible");
                }
            }
        });
        $(function () {
            const form = $("#purchaseGiftForm");
            const cloneInput = (giftBlock, className) => {
                const clone = giftBlock.find("#firstGroup").clone();
                clone.removeAttr("id");
                clone.removeAttr("style");
                clone.addClass(className || null);
                clone.appendTo(giftBlock);
                clone.find(".btnAddRecipient").on("click", () => {
                    clone.addClass("giftInputBlock__container--created");
                    cloneInput(giftBlock, className);
                    form.trigger("change");
                });
                clone.find(".btnDeleteRecipient").on("click", () => {
                    clone.remove();
                    form.trigger("change");
                });
            };
            const giftCheckbox = $(".giftCheckbox");
            const initGiftOptions = () => {
                $("#btnGift").show();
                $("#btnStandard").hide();
                const giftBlock = giftCheckbox.closest(".column").find(".giftInputBlock");
                giftBlock.show();
                cloneInput(giftBlock, "clonedInput");
            };
            if (giftCheckbox.attr("checked")) {
                console.log("initing");
                initGiftOptions();
            }
            giftCheckbox.change(function (event) {
                if (event.target.checked) {
                    initGiftOptions();
                } else {
                    $("#btnGift").hide();
                    $("#btnStandard").show();
                    const col = $(this).closest(".column");
                    const giftBlock = col.find(".giftInputBlock");
                    giftBlock.hide();
                    col.find(".clonedInput").remove();
                    //Checkbox has been unchecked
                }
                setTimeout(() => {
                    form.trigger("change");
                }, 50);
            });

            const checkPrice = () => {
                const keys = Array.from(marathonPrices.keys());
                let res = 0;

                keys.forEach((k) => {
                    const price = marathonPrices.get(k);
                    const inputSelf = form.find(`input[name='self[${k}]']`)[0];
                    if (inputSelf && inputSelf.checked) {
                        res += price;
                    }
                    const inputGift = form.find(`input[name='gift[${k}]']`)[0];
                    if (inputGift.checked) {
                        form.find(`.clonedInput input[name='name[${k}][]']`).each(function () {
                            // if ((this.value || "").length > 0) {
                                res += price;
                            // }
                        });
                    }
                });
                $("#finalPrice").html(res);
            };

            form.on("change", function () {
                checkPrice();
            });
            setTimeout(() => {
                form && form.trigger("change");
            }, 50);
        });

        $(function () {
            $("#sidebar-toggle").on("click",function (e) {
                e.preventDefault();
                var el=$("#main");
                el.toggleClass("no-margin");
            });
            var target = $('#body')[0];
            $('#fullscreen').click(function () {
                if (screenfull.enabled) {
                    screenfull.toggle(target);
                }
            });

            if ($('.creditly-wrapper').length) {
                var creditly = Creditly.initialize(
                    '.creditly-wrapper .expiration-month-and-year',
                    '.creditly-wrapper .credit-card-number',
                    '.creditly-wrapper .security-code',
                    '.creditly-wrapper .card-type'
                );
            }


            $('body').delegate('.js-favorite-video', 'click', function (e) {
                e.preventDefault();
                var $el = $(e.currentTarget);
                var url = $el.data('url');
                var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
                $.ajax({
                    url: url,
                    type: 'POST',
                    data: {_token: CSRF_TOKEN},
                    dataType: 'JSON',
                    success: function (data) {
                        $el.siblings('.hidden').toggleClass('hidden');
                        $el.toggleClass('hidden');
                    }
                });
            });

            var agreementCheckbox = document.getElementsByClassName('js-agreement-checkbox');
            if (agreementCheckbox.length > 0 && agreementCheckbox[0].checked) {
                $('.js-payment-btn').prop('disabled', false)
            } else {
                $("#txtAge").hide();
            }
            $('.js-agreement-checkbox').on('change', function (e) {
                var $el = $(e.currentTarget);
                var $button = $('.js-payment-btn');
                if ($el.is(':checked')) {
                    $button.prop('disabled', false);
                } else {
                    $button.prop('disabled', true);
                }
            })

        });
    }
)(jQuery);








